const transformDomain = 'https://images.matas.dk/pxy/';
const transformDomainLength: number = transformDomain.length;

export function getCloudFlareProxiedUrl(src: string): string {
    //if (src.includes('.hdk')) return src;

    let url = src;

    if (url.startsWith(transformDomain)) {
        url = url.substring(transformDomainLength);
    }

    const encodedSrc = url;

    return `${transformDomain}${encodedSrc}`;
}
